import { createSingleton } from './helper';
import NetworkManager from './network-manager';
const instance = NetworkManager.create({
    autoRun: false,
});
// 创建全局单例
export const network = createSingleton(instance);
//# sourceMappingURL=index.js.map